import Header from "../../shared/FanHeader/header";
import Footer from "../../shared/footer/footer";
import WishlistComponent from "../../components/fan/wishlist";

const Wishlist = () => {
	return (
		<div>
			<Header />
			<WishlistComponent />
			<Footer />
		</div>
	);
};

export default Wishlist;
